import type { TranslatedFields } from '@/interfaces/Language.interfaces'
import type { PerimeterType } from '@/contexts/perimeters/Perimeters.interfaces'
import { type Owner } from '@/contexts/shared/owners/Owners.interfaces'

export enum MeasureActionType {
  MEASURE = 'm',
  ACTION = 'r',
}

export interface GetPriorityScale {
  priority_scale?: PolicyPriorityScale
  perimeter_priority_level?: PolicyPriorityLevel
}

export interface PolicyPriorityScale {
  id: number
  identifier: string
  name: TranslatedFields
  priority_levels: PolicyPriorityLevel[]
}

export interface PolicyPriorityLevel {
  id: number
  name: TranslatedFields
  value: number
  nb_requirements: number
}

export interface PolicyPerimeter {
  id: number
  name: string
  tags: PolicyPerimeterTag[]
  identifier: string
  view_right: boolean
  type: PerimeterType
  priority: number
}

export interface PolicyPerimeterTag {
  id: number
  tag: string
  children_: PolicyPerimeterTagChildren[]
  is_root: boolean
}

export interface PolicyPerimeterTagChildren {
  child_id: number
  name: string
}

export interface PolicyCreateActionsParams {
  perimeter_id: number
  requirement_ids: number[]
  action_plan_id?: number | null
  action_plan_name?: TranslatedFields | null
  manager?: Owner | null
}

export interface PolicyCreatedActionsResponse {
  action_plan_id: number
  action_plan_name: TranslatedFields
  nb_of_groups_created: number
  nb_of_actions_created: number
}

export enum PolicyPublicType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export interface PolicyCounts {
  total: number
  isOneExpired: boolean
}

export interface PolicyRowPerimeter {
  perimeter_id: number
  policy_id: number
  identifier: string
  name: string
  percentage: number | null
  priority: number | null
  nb_controls: number | null
  edit_priority_right: boolean
}

export interface PolicyRowPriorityLevel {
  id: number
  name: string
  value: number | null
  icon: string | null
  color: string | null
}

export interface PolicyRowPriorityScale {
  id: number
  name: string
  icon: string | null
  color: string | null
  indicator_levels: PolicyRowPriorityLevel[]
}

export interface PolicyRow {
  id: number
  identifier: string
  name: string
  is_public: boolean
  public_type: PolicyPublicType | null
  current_version: number | null
  edit_right: boolean
  perimeters__: PolicyRowPerimeter[]
  priority_scale: PolicyRowPriorityScale | null
  gap_counts: PolicyCounts | null
  exemption_counts: PolicyCounts | null
  eval_perf: number | null
  coverage_perf: number | null
  run_coverage_perf: number | null
}

export interface PoliciesListResult {
  objects: PolicyRow[]
}

export interface PolicyScore {
  id: number
  eval_perf: number | null
  coverage_perf: number | null
  run_coverage_perf: number | null
}

export interface PolicyPerimeterAssociation {
  perimeter_id: number
  policy_id: number
  percentage: number
  priority: number
}
